// @ts-nocheck

import { memo, forwardRef, FC } from 'react'
import { InputGroup } from '@chakra-ui/react'

import { MaskedInput } from 'components'
import { brazilianDateMask } from 'utils/masks'
import { DynamicFieldProps } from '../..'

type Props = DynamicFieldProps

const DateInputFilterField: FC<Props> = forwardRef<any, Props>(({ name, onChange, ...props }, ref) => {
  return (
    <InputGroup width="100%" minWidth="min-content">
      <MaskedInput name={name} mask={brazilianDateMask} ref={ref} inputMode="numeric" onChange={onChange} {...props} />
    </InputGroup>
  )
})

export default memo(DateInputFilterField)
